$(".article ol").each(function (i,ol) {
    $(ol).find("li").each(function (i,li) {
        console.log(i)
        let current = 1
        if(i + 1 < 10){
            $(li).attr("data-num",`0${i+1}`)
        } else{
            $(li).attr("data-num",`${i+1}`)
        }
    })
})
